import { useFetchDocumentRetention } from './useFetchDocumentRetention'
import { queryKeys as documentQueryKeys, type QueryDocumentByIdCacheData } from '../useQueryDocument'

const update = () => {
  const { update } = useFetchDocumentRetention()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: update,
    onMutate: (variables) => {
      queryClient.cancelQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onError: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onSuccess: (responseData, variables) => {
      queryClient.setQueriesData<QueryDocumentByIdCacheData>({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      }, (oldData) => {
        if (!oldData)
          return oldData

        const updated = {
          ...oldData,
          data: {
            ...oldData.data,
            retention: responseData.data,
          },
        }

        return updated
      }, {
        updatedAt: Date.now(),
      })
    },
  })
}

export const useMutationDocumentRetention = {
  update,
}
